import React from 'react';

const C = {
  teal: '#50B8A8', text: '#f8fafc', secondary: '#94a3b8',
  surface: '#1e293b', divider: '#334155',
} as const;

interface EditSliderProps {
  label: string;
  value: number;
  min: number;
  max: number;
  onChange: (value: number) => void;
  unit?: string;
}

export function EditSlider({ label, value, min, max, onChange, unit = '' }: EditSliderProps) {
  const pct = ((value - min) / (max - min)) * 100;
  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
        <span style={{ fontSize: 13, fontWeight: 500, color: C.text }}>{label}</span>
        <span style={{ fontSize: 12, color: value !== 0 ? C.teal : C.secondary, fontWeight: 600, minWidth: 32, textAlign: 'right' }}>
          {value > 0 ? `+${value}` : value}{unit}
        </span>
      </div>
      <input
        type="range"
        min={min}
        max={max}
        value={value}
        onChange={e => onChange(Number(e.target.value))}
        onDoubleClick={() => onChange(0)}
        style={{
          width: '100%', height: 6, appearance: 'none', WebkitAppearance: 'none',
          background: `linear-gradient(90deg, ${C.teal} 0%, ${C.teal} ${pct}%, ${C.divider} ${pct}%, ${C.divider} 100%)`,
          borderRadius: 3, cursor: 'pointer', outline: 'none',
        }}
      />
    </div>
  );
}
